import { useSelector } from 'react-redux'
import { useTranslation } from 'react-i18next'

import { ELEVATEOS_LOGO_ALT } from '@/constants'

import { selectUserData } from '../../../reducers/userDataReducer'
import { useMobileAppName } from '../../../hooks/use-mobile-app-name'

const DownloadApp = () => {
  const { t } = useTranslation(['client-reservations'])
  const userData = useSelector(selectUserData)

  const appName = useMobileAppName()

  return (
    <div className={`download-app ${!userData ? 'is-loading' : ''}`}>
      <div className="download-app__container">
        <div className="download-app__content">
          <div className="download-app__icon">
            <img src="/images/logo/elevateos-logo-square-white.png" alt={ELEVATEOS_LOGO_ALT} />
          </div>
          <div className="download-app__text-content">
            <h1 className="download-app__title">
              {t('client-reservations:downloadApp.title', { appName })}
            </h1>
            <p className="download-app__description">
              {t('client-reservations:downloadApp.description')}
            </p>
          </div>
          <div className="download-app__badges">
            <div className="download-app__badges-row">
              <a
                href={userData?.buildingId?.iosAppStoreLink || ''}
                target="_blank"
                rel="noopener noreferrer"
              >
                <img
                  alt={t('client-reservations:downloadApp.appStoreAlt')}
                  src="/images/get-appstore-app.svg"
                />
              </a>
              <a
                href={userData?.buildingId?.googlePlayLink || ''}
                target="_blank"
                rel="noopener noreferrer"
              >
                <img
                  alt={t('client-reservations:downloadApp.googlePlayAlt')}
                  src="/images/get-google-play-app.svg"
                />
              </a>
            </div>
            <div className="download-app__powered-by">
              <span className="download-app__powered-by-text">
                {t('client-reservations:downloadApp.poweredBy')}
              </span>
              <img
                alt={ELEVATEOS_LOGO_ALT}
                className="download-app__powered-by-logo"
                src="/images/logo/elevateos-logo-wide-black.svg"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default DownloadApp
